<h5 mat-dialog-title>{{data.header}}</h5>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions style="float: right">
  <button class="btn btn-outline-dark dialogbtn" (click)="onOkClick()">Ok</button>
</div>